(function (factory) {
    'use strict';
    if (typeof define === 'function' && define.amd) {
        define(['./jquery'], factory);
    } else if (typeof exports !== 'undefined') {
        module.exports = factory(require('./jquery'));
    } else {
        factory(jQuery);
    }
}(function ($) {
    document.addEventListener('DOMContentLoaded', function () {
	    myFunction();
    }, false);

    $(document).ready(function() {
        myFunction();
    });

    window.addEventListener("scroll", myFunction);

    function myFunction() {
        var popup = document.getElementById("pdfDownloadPopUp");
        var variantPopup = document.getElementById("variantPopUp");
        var footer = document.getElementsByClassName("footer")[0];

        if ((window.innerHeight + window.pageYOffset + 30 < footer.offsetTop)) {
            popup.classList.add("stick");
        }
        else {
            popup.classList.remove("stick");
        }

        if (variantPopup != null && variantPopup.classList.contains("visible")) {
            popup.classList.add("popup-above");
        } else {
            popup.classList.remove("popup-above");
        }
    }
}));